<template>
  <div
    id="userdetails"
    class="
      shadow-xl
      rounded-md
      lg:border-2 lg:border-blue-600 lg:p-10 lg:ml-6
      md:ml-10
      relative
    "
  >
    <div
      id="formtitle"
      class="
        border-2
        w-full
        flex
        justify-center
        items-center
        bg-blue-600
        text-blue-200
      "
    >
      <div class="text-sm breadcrumbs">
        <ul>
          <li>
            <a>Application</a>
          </li>
          <li>
            <a>Other Information</a>
          </li>
        </ul>
      </div>
    </div>

    <vee-form
      :validation-schema="schema"
      class="
        lg:h-auto
        w-full
        flex flex-col
        items-center
        justify-center
        px-8
        py-4
        mx-3
        lg:grid lg:grid-flow-row lg:grid-cols-3 lg:gap-2
      "
      @submit="expInfo"
    >
      <div class="form-control w-full">
        <label for="Present_salary" class="label">
          <span class="label-text">Present Salary</span></label
        >
        <vee-field
          name="Present_salary"
          v-model="Present_salary"
          type="number"
          id="Present_salary"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="Present_salary" />
      </div>
      <div class="form-control w-full">
        <label for="Expected_Salary" class="label">
          <span class="label-text">Expected Salary</span></label
        >
        <vee-field
          name="Expected_Salary"
          v-model="Expected_Salary"
          type="number"
          id="Expected_Salary"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="Expected_Salary" />
      </div>
      <div class="form-control w-full">
        <label for="Height" class="label">
          <span class="label-text">Height in cms</span></label
        >
        <vee-field
          name="Height"
          v-model="Height"
          type="number"
          id="Height"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="Height" />
      </div>
      <div class="form-control w-full">
        <label for="Weight" class="label">
          <span class="label-text">Weight in kgs</span></label
        >
        <vee-field
          name="Weight"
          v-model="Weight"
          type="number"
          id="Weight"
          class="input input-bordered w-full"
        />
        <ErrorMessage class="text-red-600" name="Weight" />
      </div>
      <div class="p-6 card bordered">
        <div class="form-control">
          <label class="cursor-pointer label">
            <span class="label-text">Physical Defects or Disability</span>
            <label for="Other" class="label">
              <span class="label-text font-semibold">Yes</span></label
            >
            <vee-field
              name="Other"
              v-model="Other"
              type="radio"
              id="Other"
              value="Y"
              class="radio"
            />
            <label for="Other" class="label">
              <span class="label-text font-semibold">No</span></label
            >
            <vee-field
              name="Other"
              v-model="Other"
              type="radio"
              id="Other"
              value="N"
              class="radio"
            />
          </label>
        </div>
      </div>
      <div
        id="button"
        class="from-control w-full lg:col-end-3 lg:col-start-1 lg:col-span-2"
      >
        <button
          type="submit"
          class="btn btn-info hover:bg-blue-500 lg:w-1/3 w-full mt-5"
        >
          <span v-if="status"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              /></svg
          ></span>
          <span v-else>Save</span>
        </button>
      </div>
    </vee-form>
    <div>
      <div v-if="response" class="alert alert-info absolute bottom-12 right-3">
        <div class="flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="w-6 h-6 mx-2 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
            ></path>
          </svg>
          <label
            >Your data has been saved click next to fill more details</label
          >
        </div>
      </div>
      <div v-if="error" class="alert alert-error absolute bottom-12 right-3">
        <div class="flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="w-6 h-6 mx-2 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            ></path>
          </svg>
          <label
            >Your data is not saved please try again later or call sitra
            customer serive
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Expectation",
  data() {
    return {
      status: false,
      response: false,
      error: false,
      schema: {
        Expected_Salary: "required",
        Height: "required|min:2|max:4",
        Weight: "required|min:2|max:4",
      },
    };
  },
  created() {
    this.getExpInfo();
  },
  computed: {
    Present_salary: {
      get() {
        return this.$store.state.Candidate.application.expectation
          .Present_salary;
        // return this.$store.state.application.expectation.Present_salary;
      },
      set(value) {
        this.$store.commit("Candidate/updatePresentSalary", value);
      },
    },
    Expected_Salary: {
      get() {
        return this.$store.state.Candidate.application.expectation
          .Expected_Salary;
      },
      set(value) {
        this.$store.commit("Candidate/updateExpextedSalary", value);
      },
    },
    Height: {
      get() {
        return this.$store.state.Candidate.application.expectation.Height;
      },
      set(value) {
        this.$store.commit("Candidate/updateHeightincms", value);
      },
    },
    Weight: {
      get() {
        return this.$store.state.Candidate.application.expectation.Weight;
      },
      set(value) {
        this.$store.commit("Candidate/updateWeightinkg", value);
      },
    },
    Other: {
      get() {
        return this.$store.state.Candidate.application.expectation.Other;
      },
      set(value) {
        this.$store.commit("Candidate/updatedisability", value);
      },
    },
  },
  methods: {
    expInfo(values) {
      // console.log(values);
      // console.log(this.$store.state.application.Id);
      values.Reg_id = this.$store.state.Candidate.application.Id;
      // console.log(values);

      const jsondata = JSON.stringify(values);
      // console.log(jsondata);
      axios
        .post(
          `http://sitraonline.org.in/employementhubapi/index.php/api/InsertFinalApplication`,
          jsondata
        )
        .then((res) => {
          // console.log(res);
          if (res.status == 200) {
            this.status = true;
          }
        })
        .catch((err) => alert(err));
    },
    getExpInfo() {
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/SelectFinalApplication`,
          {
            Reg_id: sessionStorage.getItem("id"),
          }
        )
        .then((res) => {
          if (res.data.length == 0) {
            this.Present_salary = "";
            this.Expected_Salary = "";
            this.Height = "";
            this.Weight = "";
            this.Other = "";
          } else if (res.data.length > 0) {
            this.Present_salary = res.data[0].Present_salary;
            this.Expected_Salary = res.data[0].Expected_Salary;
            this.Height = res.data[0].Height;
            this.Weight = res.data[0].Weight;
            this.Other = res.data[0].Other;
          }
        })
        .catch((err) => alert(err.mesage));
    },
  },
};
</script>
